import React from 'react'
import PropTypes from 'prop-types'
import {Redirect } from 'react-router-dom'
import userState from '../store/userState'

class Homepage extends React.Component {
  render () {
    if(!userState.login){ return <Redirect to='/login' />}
    return(
      <Redirect to='/iot/events' />
    )
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/container/Homepage.js